// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PatientOverview from './data'

export default function PatientOverviewFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PatientOverview">
      <PatientOverview {...props}>
        {children}
      </PatientOverview>
    </Flow>
  )
}
